import React from "react";
import { Link } from "react-router";
import PropTypes from 'prop-types';

import TeamIcon from "./TeamIcon.js";
import style from "./TeamIcons.css";

const TeamIcons = ({ teams }) => {
  return (
    <div className={style.teamIcons}>
      {teams.map((team, idx) => {
        const url = `/openings?department=${idx}`;

        return (
          <Link
            className={style.link}
            key={idx}
            to={url}>
            <TeamIcon team={team} />
            <div className="style.name">{team.name}</div>
          </Link>
        );
      })}
    </div>
  );
};

TeamIcons.propTypes = {
  teams: PropTypes.array.isRequired
};

export default TeamIcons;



// WEBPACK FOOTER //
// ./component/TeamIcons/index.js